import { Box, Paper, Typography, useTheme } from '@mui/material';
import { FC, useEffect, useMemo } from 'react';
import { GoPlus } from "react-icons/go";
import { useNavigate } from 'react-router-dom';
import { Button } from '../../../Components/Form/Button/button.scomponent';
import { Table } from '../../../Components/Table/table.component';
import { BaseContentPage } from '../../../Components/Templates/BaseContentPage/base-content-page.componen';
import { BaseScreen } from '../../../Components/Templates/BaseScreen/basescreen.component';

import { Can } from '../../../Components/Can';
import { Flex } from '../../../Components/Flex/flex.component';
import { Loader } from '../../../Components/Loader';
import { Placeholder } from '../../../Components/Placeholder/placeholder.component';
import { useListStocks } from './stocks-list.hook';

import { ButtonActionMenu } from '../../../Components/Form/ButtonActionsMenu/button-action-menu.component';
import { ListMangerStocksUseCase } from '../../../Usecase/Stocks/list-manager-stocks-usecase';
import { ListProductUseCase } from '../../../Usecase/Products/list-product-usecase';
import { ListStocksUseCase } from '../../../Usecase/Stocks/list-stocks-usecase';

interface IStocksList {
  listStocksUseCase: ListStocksUseCase
}

const StocksList : FC<IStocksList> = ({ listStocksUseCase }) => {
    const theme = useTheme()
    const navigate = useNavigate()

    const { listStocks, list, totalRegisters, control, loading, setShowFiltersModal, showFiltersModal } = useListStocks({
   
      listStocksUseCase
    })





    const columns = useMemo(() => {
        const createColumns: any[] = [
          {
            field: 'photo',
            headerName: 'Imagem',
            renderCell: (params: any) => <Box component='img' src={params.value} sx={{ width: '80px', height: '80px', objectFit: 'contain'}} />
          },
          
          {
            field: 'internalName',
            headerName: 'Nome Importado',
            flex: 1,
            renderCell: (params: any) => <Flex height='100%' alignItems='center'><Typography sx={{flexWrap: 'wrap', whiteSpace: 'normal', wordBreak: 'break-word'}} >{params.value}</Typography></Flex>
          },
          {
            field: 'name',
            headerName: 'Nome Amigável',
            flex: 1,
            renderCell: (params: any) => <Flex height='100%' alignItems='center'><Typography sx={{flexWrap: 'wrap', whiteSpace: 'normal', wordBreak: 'break-word'}} >{params.value}</Typography></Flex>
          },
          {
            field: 'allocatedStockQuantity',
            headerName: 'Empenho',
            width: 100,
            headerAlign: 'center',
            align: 'center',
            renderCell: (params: any) => <Flex height='100%' alignItems='center' justifyContent='center'><Typography sx={{flexWrap: 'wrap', whiteSpace: 'normal', wordBreak: 'break-word'}} >{params.value}</Typography></Flex>
          },
          {
            field: 'workInProgressQuantity',
            headerName: 'Produção',
            width: 100,
            headerAlign: 'center',
            align: 'center',
            renderCell: (params: any) => <Flex height='100%' alignItems='center' justifyContent='center'><Typography sx={{flexWrap: 'wrap', whiteSpace: 'normal', wordBreak: 'break-word'}} >{params.value}</Typography></Flex>
          },
          {
            field: 'finishedGoodsQuantity',
            headerName: 'Acabado',
            width: 100,
            headerAlign: 'center',
            align: 'center',
            renderCell: (params: any) => <Flex height='100%' alignItems='center' justifyContent='center'><Typography sx={{flexWrap: 'wrap', whiteSpace: 'normal', wordBreak: 'break-word'}} >{params.value}</Typography></Flex>
          },
          {
            field: "actions",
            headerName: "Ações",
             renderCell: (params: any) => <ButtonActionMenu options={[
              {
                title: 'Acessar',
                onClick: () => navigate(`/stocks-details/${params.row.id}`),
              }
            ]} />
          }
        ];
      
        return createColumns;
      }, []);
   

    return (
      <Can permissions={['menu:stocks:manage']}>
         {/* <FinancialFiltersDrawer handleSelect={e => {}} open={showFiltersModal} title='Filtros' onToggle={() => setShowFiltersModal(prev => !prev)}  />   */}
        <BaseScreen>
            <Paper >
                {loading && <Loader />}
                <BaseContentPage 
                    title='Estoque'
                    search
                    searchFunction={listStocks}
                    breadcrumb={[{ title: 'Estoque', link: "/stocks-list"}, { title: 'Listagem'}]}
                    Action={() => <Flex gap={2} alignItems='center'justifyContent='flex-end'>
                      <Box />
                      {/* <Flex flexDirection='column' > */}
                        {/* <Typography variant='body1' sx={{ fontWeight: 500 }}>Visualizar:</Typography>
                        <Flex>
                          <Switch label="B2B" name="storeB2B" control={control} />
                          <Switch label="B2C" name="storeB2C" control={control} />
                        </Flex>
                      </Flex> */}

                  
                      {/* <Button LeftIcon={() => <GoPlus size={18} />} sx={{ width: '240px'}} boxLeftSx={{ gap: '10px', marginLeft: '5px'}} textSx={{ textTransform: 'Capitalize', fontWeight: 500}} onClick={() => navigate('/stocks-form')}
                    >Adicionar Movimentação</Button> */}
                    </Flex>}
                >
                  {!!list?.length ? <Table data={list} columns={columns} onPageChange={listStocks} totalCount={totalRegisters} /> : <Placeholder description='Nenhum dado encontrado.' />}
                </BaseContentPage>
              
            </Paper>
                
        </BaseScreen>
        </Can>
    )
}

export { StocksList };
